package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class DeletePostUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(
        id: String,
        totpCode: String? = null,
    ): Result<Unit> = postRepository.deletePost(id, totpCode)
}
